// Extracted mask shapes only carry a `viewBox` (no explicit width/height
// attributes), so stored width/height can be wrong. viewBox is the
// authoritative source for their real intrinsic size.
export const parseSvgViewBoxSize = (svgContent: string): { width: number, height: number } | undefined => {
  const box = parseSvgViewBox(svgContent)
  return box ? { width: box.width, height: box.height } : undefined
}

// Same as parseSvgViewBoxSize but keeps the viewBox's min-x/min-y origin —
// mask shapes are frequently authored with a non-zero origin (e.g.
// `viewBox="79.62 86.44 237.09 287.58"`), and the shape's own path/polygon
// coordinates are defined in that same offset space, not from (0,0).
export const parseSvgViewBox = (svgContent: string): { x: number, y: number, width: number, height: number } | undefined => {
  const match = svgContent.match(/viewBox=["']([^"']+)["']/i)
  if (!match) return undefined

  const parts = match[1].trim().split(/[\s,]+/).map(Number)
  if (parts.length !== 4 || parts.some(n => Number.isNaN(n))) return undefined

  const [x, y, width, height] = parts
  if (!width || !height || x === undefined || y === undefined) return undefined

  return { x, y, width, height }
}
